export default "__VITE_ASSET__237053ad__"